import React from 'react';
import Modal from 'react-modal';
import { find, isEmpty, isNil, map, trim } from 'lodash';
import translateService from '../../../common/translateService';
import {
  getAvailabilityLabel,
  getAvailabilityCssClass,
} from '../../../services/product/productService';
import common from '../../../common/common';

const ProductOptionsOther = (props) => {
  Modal.setAppElement('body');

  const handleClick = (e) => {
    props.updateSelection(e, false);
    props.updateModalState(props.attrName);
  };

  const handleModalStateChange = () => {
    props.updateModalState(props.attrName);
  };

  const generateSelectionPropValues = () => {
    return map(props.values, (v, i) => {
      const val = props.isKit ? String(v.kitOptionId) : v.value;
      return (
        <button
          type='button'
          className={`prd-option-other ${getAvailabilityCssClass(
            props.isKit,
            props.selection,
            props.options,
            props.attrName,
            val,
            props.qtySelected,
          )} ${
            v.value === props.selection[props.attrName] ? 'selected' : ''
          }`.trim()}
          data-value={val}
          data-attr={props.attrName}
          key={i}
          onClick={handleClick}
        >
          <span>{v.value}</span>
          {getAvailabilityLabel(
            props.isKit,
            props.selection,
            props.options,
            props.attrName,
            val,
            props.qtySelected,
          )}
        </button>
      );
    });
  };

  const generateSelectionWithNoPropValues = () => {
    return (
      <div
        className={`prd-option-other single-option-availability ${getAvailabilityCssClass(
          props.isKit,
          props.selection,
          props.options,
          props.attrName,
          props.kitOptionId,
          props.qtySelected,
        )}`.trim()}
        data-value={props.kitOptionId}
        data-attr={props.attrName}
      >
        {getAvailabilityLabel(
          props.isKit,
          props.selection,
          props.options,
          props.attrName,
          props.kitOptionId,
          props.qtySelected,
        )}
      </div>
    );
  };

  const otherSelection = !isEmpty(props.values) ? (
    generateSelectionPropValues()
  ) : (
    <>
      {!isEmpty(props.nameAttributes) && (
        <div
          className='prd-option-other single-option'
          data-value={props.kitOptionId}
          data-attr={props.attrName}
        >
          {props.nameAttributes}
        </div>
      )}
      {generateSelectionWithNoPropValues()}
    </>
  );

  const getAttributeSelectText = () => {
    if (props.selection[props.attrName]) {
      if (props.isKit) {
        console.log('selection: ', props.selection);
        const attribute = find(
          props.attributes,
          (i) => i.fieldId === props.attrName,
        );
        if (!isNil(attribute)) {
          const val = find(
            attribute.values,
            (v) => String(v.kitOptionId) === props.selection[props.attrName],
          );

          console.log('val: ', val);
          return isNil(val) ? (
            ''
          ) : (
            <>
              {val.value} -{' '}
              {getAvailabilityLabel(
                props.isKit,
                props.selection,
                props.options,
                props.attrName,
                props.selection[props.attrName],
                props.qtySelected,
              )}
            </>
          );
        }
      }
      return (
        <>
          {props.selection[props.attrName]} -{' '}
          {getAvailabilityLabel(
            props.isKit,
            props.selection,
            props.options,
            props.attrName,
            props.selection[props.attrName],
            props.qtySelected,
          )}
        </>
      );
    }
    return translateService.get(`productDetail.select`);
  };

  return (
    <div className='prd-option prd-options-other'>
      <h2
        className={trim(
          `prd-options-other-text ${
            !isEmpty(props.values) ? '' : 'single-option'
          }`,
        )}
      >
        {props.isKit ? (
          <>
            {props.qtyNeeded > 1 ? (
              <span className='prd-options-other-text-qtyNeeded'>
                {props.qtyNeeded} x&nbsp;
              </span>
            ) : (
              <></>
            )}
            <a
              className='prd-options-other-link'
              href={common.getSiteUrl(window.$pathBase + props.slug)}
              target='_blank'
            >
              <span className='prd-options-name'>{props.name}</span>
            </a>
          </>
        ) : (
          <span className='prd-options-name'>{props.name}</span>
        )}
      </h2>

      {otherSelection.length > 0 ? (
        <div
          className={
            !isEmpty(props.values)
              ? 'prd-options-other-select'
              : 'prd-options-other-single-option'
          }
        >
          <button
            type='button'
            className='prd-modal-button open'
            onClick={handleModalStateChange}
          >
            <span
              className={
                props.selection[props.attrName]
                  ? getAvailabilityCssClass(
                      props.isKit,
                      props.selection,
                      props.options,
                      props.attrName,
                      props.selection[props.attrName],
                      props.qtySelected,
                    )
                  : ''
              }
            >
              {getAttributeSelectText()}
            </span>
            <span
              style={
                props.isMobile
                  ? {
                      transform: 'rotate(90deg)',
                      marginRight: '4px',
                    }
                  : {}
              }
            >
              &#9002;
            </span>
          </button>
          <Modal
            isOpen={props.modalsState[props.attrName]}
            onRequestClose={handleModalStateChange}
            contentLabel={translateService.get(`productDetail.select`)}
            closeTimeoutMS={500}
            className={{
              base: 'prd-modal-content',
              afterOpen: 'prd-modal-content-afterOpen',
              beforeClose: 'prd-modal-content-beforeClose',
            }}
            overlayClassName={{
              base: 'prd-modal-overlay',
              afterOpen: 'prd-modal-overlay-afterOpen',
              beforeClose: 'prd-modal-overlay-beforeClose',
            }}
            shouldFocusAfterRender={false}
          >
            <div className='prd-options-other-wrapper'>
              <div className='prd-options-heading'>
                <h3>{translateService.get(`productDetail.select`)}</h3>
                <button
                  type='button'
                  className='prd-modal-button close'
                  onClick={handleModalStateChange}
                >
                  &times;
                </button>
              </div>
              <div className='prd-options-other-container'>
                {otherSelection}
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        otherSelection
      )}
    </div>
  );
};

export default ProductOptionsOther;
